import { ShieldQuestion } from "lucide-react";
import { DivPxNew } from "styles/padding/TailwindStyles";
import { GlobalAnimatedLayout } from "~/components/animation/GlobalAnimatedLayout";
import GlobalTextTitleH3 from "~/components/global/GlobalTextTitleH3";
import Separator from "~/components/global/Separator";
import { Text1 } from "~/components/typographies/Texts";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "~/components/ui/accordion";

export const faqData = [
  {
    id: "faq-1",
    question: "Apakah arsinesia.com bisa menangani bangun rumah dari nol?",
    answer:
      "Ya, kami siap membantu proses pembangunan rumah dari awal, mulai dari desain, perencanaan anggaran, hingga pelaksanaan di lapangan.",
  },
  {
    id: "faq-2",
    question: "Bisakah saya merenovasi sebagian rumah saja?",
    answer:
      "Tentu saja. Kami melayani renovasi sebagian seperti dapur, kamar mandi, atap, hingga renovasi total untuk mengubah tampilan rumah Anda.",
  },
  {
    id: "faq-3",
    question: "Berapa lama waktu pengerjaan bangun/renovasi rumah?",
    answer:
      "Waktu pengerjaan tergantung pada skala dan kompleksitas proyek. Kami akan memberikan estimasi durasi setelah survey dan perencanaan awal secara GRATIS, karena kami percaya bahwa transparansi adalah kunci dalam setiap proyek.",
  },
  {
    id: "faq-4",
    question:
      "Saya masih 3 bulan lagi memulai proyek karena menunggu dana, apakah bisa konsultasi dulu?",
    answer:
      "Tentu saja bisa. Kami menyarankan untuk berkonsultasi sedini mungkin agar Anda memiliki perencanaan yang matang saat proyek dimulai nanti.",
  },
  {
    id: "faq-5",
    question: "Apakah proyek saya akan diawasi oleh tim profesional?",
    answer:
      "Ya, setiap proyek diawasi langsung oleh Bapak Ronny Abdillah, MT. dan ditangani oleh mandor serta tim teknis berpengalaman agar kualitas, waktu, dan standar pengerjaan tetap terjaga. Kami juga menyediakan laporan progres mingguan agar Anda dapat memantau perkembangan proyek secara transparan.",
  },

  {
    id: "faq-6",
    question: "Bagaimana skema pembayaran di arsinesia.com?",
    answer:
      "Pembayaran dilakukan bertahap sesuai progres pekerjaan, mulai dari tanda jadi, DP, pembayaran tengah proyek, hingga pelunasan saat serah terima proyek.",
  },
  {
    id: "faq-7",
    question: "Apakah ada garansi?",
    answer:
      "Ya, karena kami menggunakan standar dan bahan material yang bisa dipertanggungjawabkan, maka dari itu kami berani memberikan garansi selama 6 bulan setelah serah terima proyek untuk memastikan kualitas dan kepuasan Anda.",
  },
  {
    id: "faq-8",
    question: "Bagaimana cara memulai proyek bersama arsinesia.com?",
    answer:
      "Anda cukup hubungi kami melalui WhatsApp atau isi formulir di website. Tim kami akan mengatur jadwal konsultasi dan survey lokasi jika dibutuhkan.",
  },
];

export const JasaBangunRumahDiBekasiSect8FAQ = () => {
  return (
    <>
      <Separator />
      <div className="w-global mx-auto flex flex-col lg:flex-row gap-5 lg:gap-20">
        {/* ============================
                      LEFT — STICKY TITLE
                  ============================ */}
        <div className="lg:w-[35%] w-full">
          <div className="lg:sticky lg:top-32 lg:pt-10">
            <GlobalAnimatedLayout direction="bottom" threshold={0.2}>
              <GlobalTextTitleH3
                center
                title="Masih Ragu?"
                desc=" Temukan jawaban dari berbagai keraguan umum sebelum Anda memulai proyek bersama kami."
              />
            </GlobalAnimatedLayout>
          </div>
        </div>

        {/* ============================
                      RIGHT — MAIN CONTENT
                  ============================ */}
        <div className=" lg:w-[65%] w-full flex flex-col gap-6">
          <Accordion
            type="single"
            collapsible
            className="bg-black px-[1rem] pb-[1rem] rounded-xl w-full mx-auto mt-[1rem]"
          >
            {faqData.map((faq) => (
              <AccordionItem key={faq.id} value={faq.id}>
                <AccordionTrigger className="text-white">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="p-[1rem] bg-yellow-500 rounded-lg mb-[1rem] text-black">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </>
  );
};
